// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"eca01658","186":"976aae30","409":"e307bb9c","807":"976aae30","815":"976aae30"}[chunkId] + ".chunk.css";
};